// extracted by mini-css-extract-plugin
export default {"diagnoses":"styles_diagnoses__ZqsFW"};